
import { __date } from "Utils/Dates/Date";
import { useEffect, useState } from "react";

const TEN_SEC = 1000 * 10;

export default function TimeSince(props) {

  const [timeSince, setTimeSince] = useState("just now");
  const [time, setTime] = useState(props.time);
  const [refreshTime,] = useState(props.refreshTime || TEN_SEC);

  useEffect(() => {
    setTime(props.time);
  }, [props]);

  useEffect(() => {
    setTimeSince(__date.timeSince(time));

    const interval = setInterval(() => {
      setTimeSince(__date.timeSince(time));
    }, refreshTime);

    return () => clearInterval(interval);

  }, [time, refreshTime]);

  return (
    <>{timeSince}</>
  )
}
